export default "/profile/images/instruction-2-ru.webp?17c66041b9bbd34affbb4cae66afdfef";